import {LocationContext} from "@ots-frontend/ots-data";
import {plainMapEntity, UnitInfoPanelView, useLiveMapNow} from "@ots-frontend/ots-ui-tw";
import {useQuickPanelClose} from "../../QuickPanelContainer/QuickPanelContainer";
import {renderMapEntityAnchor} from "../map-entity-anchor";

export type LocationContextInfoPanelProps = {
  ctx: LocationContext
  /** Off where the app has no profiles to open, e.g. HubGo: names read as plain text. */
  linkEntities?: boolean
}

/** The live map's panel for a driver, trailer or vehicle, with links to the profiles it names. */
export const LocationContextInfoPanel = ({ctx, linkEntities = true}: LocationContextInfoPanelProps) => {
  const onClose = useQuickPanelClose()
  const now = useLiveMapNow()
  return <UnitInfoPanelView ctx={ctx} now={now} renderEntity={linkEntities ? renderMapEntityAnchor : plainMapEntity} onClose={onClose}/>
}
